import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const getResAddUser = (isSuperAdmin: boolean) => {
  let schema = yup.object({
    firstname: yup
      .string()
      .trim()
      .required('First Name is required')
      .min(1, 'First Name must be at least 1 character'),
    lastname: yup
      .string()
      .trim()
      .required('Last Name is required')
      .min(1, 'Last Name must be at least 1 character'),
    email: yup.string().required('Email is required').email('Email is not a valid email address'),
    phone: yup.string().nullable().trim(),
    centers: yup.array(),
    password_api: yup.string(),
  })

  if (isSuperAdmin) {
    schema = schema.shape({
      customers: yup.array().min(1, 'At least one Customer is required'),
    })
  }

  return yupResolver(schema)
}

export default getResAddUser